module.exports = __webpack_public_path__ + "static/media/hackerrank.04707c69.png";